/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import { type IndicatorColorsMap } from '@bbkAdminComponents/indicators/indicator-colors';

import '@bbkAdminComponents/indicators/styles/dot.scss';

type Props = {
  dotColor: keyof typeof IndicatorColorsMap;
  className?: Argument;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>;
export const DotIndicator: React.FC<React.PropsWithChildren<Props>> = ({
  dotColor,
  className,
  ...restProps
}) => (
  <div className={cs('dot-indicator', dotColor, className)} {...restProps} />
);
